export { default } from './Facts';
